// extracted by mini-css-extract-plugin
module.exports = {"noteText":"styles-module__noteText___1m6Wh"};